@if (isFeatureAvailable) {
<ng-content></ng-content>
} @if (!isFeatureAvailable) {

<div (click)="facade.showFeatureInfo(mode, feature)">
  @if (customTpl) {
  <ng-template [ngTemplateOutlet]="customTpl"></ng-template>
  } @else {

  <rt-button variant="outline">
    <rt-icon name="add"></rt-icon>
    <div layout-horizontal layout-align-items-center>
      {{ defaultBtnText }}
      <rt-icon
        name="upgrade"
        size="small-x"
        [colorToken]="colorToken"
        margin-left-small-x
      ></rt-icon>
    </div>
  </rt-button>

  }
</div>

}
